/*
  Unified Fields Props Definition
*/
import {FormattedMessage} from "react-intl"
import React from "react"
import moment from "moment"

export default {
	load() {
		return {
			fields: {
				recordId: {},
				version: {
					rules: "string"
				},
				print: {
					value: false,
					rules: "boolean"
				},
				examinationName: {
					label: <FormattedMessage id="Patient.form.patientrecord.examinationName" />,
					rules: ""
				},
				OF: {
					label: <FormattedMessage id="Patient.form.problemForm.OF" />,
					rules: "required"
				},
				record: {
					label: <FormattedMessage id="Patient.form.patientrecord.ST" />
					// rules: "required"
				},
				iexam: {
					label: <FormattedMessage id="Common.label.iexam" />
					// rules: "required"
				},
				diagnosisSummary: {
					label: <FormattedMessage id="Patient.form.patientrecord.DiagnosisSummary" />
				},
				Recomm: {
					label: <FormattedMessage id="Patient.form.problemForm.Recomm" />
				},
				doctorPersonnelExpertiseId: {
					label: <FormattedMessage id="Patient.form.patientrecord.doctor" />
				},
				doctorPersonnelId: {},
				doctorExpertiseId: {},
				examdate: {
					label: <FormattedMessage id="Patient.form.patientrecord.dateOfExam" />,
					rules: "required",
					type: "date",
					value: moment()
				},
				requestdate: {
					label: <FormattedMessage id="Patient.form.patientrecord.dateOfRequest" />,
					type: "date"
				},
				doctorOUPZS: {
					label: <FormattedMessage id="Patient.form.patientrecord.doctorOUPZ" />
				},
				doctorOUPZSId: {},
				note: {
					label: <FormattedMessage id="Patient.form.patientrecord.note" />
				},
				dispensarisation: {
					label: <FormattedMessage id="Patient.form.patientrecord.dispensarisation" />,
					type: "checkbox"
				},
				recordPriority: {
					label: <FormattedMessage id="Patient.form.patientrecord.recordPriority" />,
					rules: "required",
					value: "1"
				},
				confidentialityLevel: {
					label: <FormattedMessage id="Patient.form.patientrecord.confidentialityLevel" />,
					rules: "required",
					value: "common"
				},
				confidentialityLevelDisable: {
					type: "checkbox",
					value: false
				},
				substitutingExpertiseId: {},
				substitutingPersonnelExpertiseId: {
					label: <FormattedMessage id="Patient.form.patientrecord.substitutingDoctor" />
				},
				substitutingDoctorOUPZS: {
					label: <FormattedMessage id="Patient.form.patientPrescription.substitutingDoctorOUPZS" />
				},
				substitutingDoctorOUPZSId: {},
				substitutingDoctor: {},
				substitutingDoctorId: {},
				diagnosisChipsForm: {
					value: "[]"
				},
				clinicalValuesChipsForm: {
					value: "[]"
				},
				deliveriesChipsForm: {
					value: "[]"
				},
				deliveriesFormAddItems: {
					value: ""
				},
				clinicalValuesSets: {
					label: <FormattedMessage id="Common.label.clinicalSetTitle" />,
					value: ""
				},
				hasDispensaryDiagnosis: {
					value: false
				},
				personnelSpecificRelId: {},
				orgunitSpecificRelId: {},
				clientSpecificRelId: {},
				question_1_yes: {
					label: "Áno",
					type: "checkbox",
					value: false
				},
				question_2_yes: {
					label: "Áno",
					type: "checkbox",
					value: false
				},
				question_3_yes: {
					label: "Áno",
					type: "checkbox",
					value: false
				},
				question_4_yes: {
					label: "Áno",
					type: "checkbox",
					value: false
				},
				question_5_yes: {
					label: "Áno",
					type: "checkbox",
					value: false
				},
				question_6_yes: {
					label: "Áno",
					type: "checkbox",
					value: false
				},
				question_7_yes: {
					label: "Áno",
					type: "checkbox",
					value: false
				},
				question_8_yes: {
					label: "Áno",
					type: "checkbox",
					value: false
				},
				question_9_yes: {
					label: "Áno",
					type: "checkbox",
					value: false
				},
				question_1_no: {
					label: "Nie",
					type: "checkbox",
					value: true
				},
				question_2_no: {
					label: "Nie",
					type: "checkbox",
					value: true
				},
				question_3_no: {
					label: "Nie",
					type: "checkbox",
					value: true
				},
				question_4_no: {
					label: "Nie",
					type: "checkbox",
					value: true
				},
				question_5_no: {
					label: "Nie",
					type: "checkbox",
					value: true
				},
				question_6_no: {
					label: "Nie",
					type: "checkbox",
					value: true
				},
				question_7_no: {
					label: "Nie",
					type: "checkbox",
					value: true
				},
				question_8_no: {
					label: "Nie",
					type: "checkbox",
					value: true
				},
				question_9_no: {
					label: "Nie",
					type: "checkbox",
					value: true
				},
				isMan: {
					type: "checkbox",
					value: false
				},
				printWithMedicationID: {}
				// drugs: {
				//   label: <FormattedMessage id="Common.label.drugs" />,
				//   rules: "string"
				// },
			}
		}
	}
}
